"use strict";
/**
* Диалог множественного выбора c поддержкой сортировки.
* 
* @class WebAccess.components.dialogs.SortableMultiSelect
* @extends WebAccess.components.dialogs.BaseMultiSelect
* @ignore
* @param {array} availableItems Список доступных элементов, в том числе элементы, которые были выбраны. Отображаются в левой части диалогового окна
* @param {array} [opt_selectedItems] Список выбранных элементов. Отображается в правой части диалогового окна
* @param {object} [opt_settings] Настройки диалогового окна
*/
(function (global) {
  var SortableMultiSelect = global.BaseMultiSelect.extend({
    init: function (availableItems, opt_selectedItems, opt_settings) {
      var instance = this;
      this._displayOptions = true;
      this._super(availableItems, opt_selectedItems, opt_settings);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Инициализация событий
     * Здесь сделаем, так что при смене сортировки данные будут считаться измененными.
     * @private     
     */
    _initEvents: function () {
      this._super();
      
      this.bind("sortingChanged", function () {
        this.isSelectionChanged = true;
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Установки параметров колонок таблицы с выбранными элементами.
     * В данном случае есть 3-й столбец
     * Для мобильных браузеров проще и эффективнее задавать ширину в процентах
     * @private
     * @return {array} параметры колонок
     */
    _getColumnsInfo: function () {
      var cols = [];          
      if (WA.ENV.isMobile()) {
        if (!this.isReadonly) {
          //cols.push({ "bVisible": true, "sWidth": "15px", "bSortable": false });
          //cols.push({ "bVisible": true, "sWidth": "360px", "bSortable": false });
          //cols.push({ "bVisible": true, "sWidth": "30px", "bSortable": false });
          cols.push({ "bVisible": true, "sWidth": "8%", "bSortable": false });
          cols.push({ "bVisible": true, "sWidth": "74%", "bSortable": false });
          cols.push({ "bVisible": true, "sWidth": "12%", "bSortable": false });
        } else {
          cols.push({ "bVisible": false, "bSortable": false });
          cols.push({ "bVisible": true, "sWidth": "100%", "bSortable": false });
          cols.push({ "bVisible": false, "bSortable": false });
        }
      } else {
        if (!this.isReadonly) {
          cols.push({ "bVisible": true, "sWidth": "14px", "bSortable": false });
          cols.push({ "bVisible": true, "sWidth": "399px", "bSortable": false });
          cols.push({ "bVisible": true, "sWidth": "31px", "bSortable": false });
        } else {
          cols.push({ "bVisible": false, "bSortable": false });
          cols.push({ "bVisible": true, "sWidth": "447px", "bSortable": false });
          cols.push({ "bVisible": false, "bSortable": false });
        }
      }
      return cols;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//    

    /**
     * параметры отрисовки выбранного элемента. В данном случае у нас добавился еще один столбец option
     * @param  {object} item элемент массива выбранных пунктов
     * @private
     * @return {string} разметка элемента
     */
    _renderSelectedItem: function (item) {

      item["display_delete"] = this.isReadonly ? 'hidden' : '';
      item["delete_title"] = L("DELETE");
      item["display_options"] = this.isReadonly ? 'hidden' : '';
      item["url"] = item["url"] || "#";
      
//      item["name"] = escapeHtml(item["name"]);

      if (!WA.ENV.isAndroid() && !$.ipad) var visibility = 'hidden';
      item["option"] = format(CT.dialog.sortingButtons, { 'is_hidden': visibility });

      return format(CT.dialog.selectedItem, item);      
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Навешиваем события на выбранный пункт
     * @param  {string} rowSelector [description]
     * @private
     */
    _initSingleSelectedItemEvents: function (rowSelector) {      
      this._super(rowSelector);
      var instance = this;

      var jRow = $(rowSelector);
      if (!$.ipad && !WA.ENV.isAndroid()) {
        jRow.hover(
            function () {
              $(this).find('.itemUp').removeClass("hidden");
              $(this).find('.itemDown').removeClass("hidden");
            },
            function () {
              $(this).find('.itemUp').addClass('hidden');
              $(this).find('.itemDown').addClass('hidden');
            }
        );
      }

      jRow.find('.itemUp').off('click.MultiSelectModalWindow').on('click.MultiSelectModalWindow', this, function (e) {
        e.data._swapRows(this, "up");
        var a = $(this);        
      });
      jRow.find('.itemDown').off('click.MultiSelectModalWindow').on('click.MultiSelectModalWindow', this, function (e) {
        e.data._swapRows(this, "down");
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    /**
     * Смена элементов местами
     * @param  {string} itemSelector пункт меню который будет перемещатся
     * @param  {string} ["up"|"down"] direction    направление перемещения
     * @private
     */
    _swapRows: function (itemSelector, direction) {
      var jPair;
      var jRow = this._jSelectedItemsTable.find(itemSelector).parent().parent();

      var id = jRow.attr('id');
      var index = this._getSelectedItemById(id);        
      var tmp;

      if (index > 0 && direction == "up") {
        jPair = jRow.prev();
        jPair.before(jRow);

        setTimeout(function () {        
          jRow.trigger('mouseover');
        }, 50);

        tmp = this.selectedItems[index - 1];
        this.selectedItems[index - 1] = this.selectedItems[index];
        this.selectedItems[index] = tmp;
        this.fire("sortingChanged");
      }
      
      if (index < this.selectedItems.length-1 && direction == "down") {        
        jPair = jRow.next();
        jPair.after(jRow);
        setTimeout(function () {          
          jRow.trigger('mouseover');
        }, 50);

        tmp = this.selectedItems[index + 1];
        this.selectedItems[index + 1] = this.selectedItems[index];
        this.selectedItems[index] = tmp;
        this.fire("sortingChanged");
      }
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
  });

  global.SortableMultiSelect = SortableMultiSelect;
})(window.WebAccess.components.dialogs);